
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const Navbar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center h-16">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <span className="text-2xl font-bold font-ibm">
              <span className="text-brand-navy">Think</span>
              <span className="text-brand-teal">Tomorrow</span>
              <span className="text-brand-navy uppercase">.ai</span>
            </span>
          </Link>
        </div>

        <div className="hidden md:flex items-center space-x-6">
          <Link 
            to="/blog" 
            className={`nav-link ${location.pathname === '/blog' ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Blog
          </Link>
          
          <Link 
            to="/ai-solutions"
            className={`nav-link ${location.pathname === '/ai-solutions' ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            AI Solutions
          </Link>
          
          <Link 
            to="/assistants"
            className={`nav-link ${location.pathname.startsWith('/assistants') ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Advisory Assistants
          </Link>
          
          <Link 
            to="/portfolio" 
            className={`nav-link ${location.pathname === '/portfolio' ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Public Portfolio
          </Link>
          
          <Link 
            to="/glossary" 
            className={`nav-link ${location.pathname === '/glossary' ? 'active' : ''}`}
            onClick={closeMobileMenu}
          >
            Glossary
          </Link>
          
          <Link to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>
            Connect
          </Link>
          
          <a 
            href="https://workflows.thinktomorrow.ai" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <Button variant="outline" size="sm">
              Workflow Navigator
            </Button>
          </a>
          
          <a href="https://app.thinktomorrow.ai/">
            <Button variant="outline" size="sm">
              Login
            </Button>
          </a>
        </div>

        <div className="md:hidden">
          <Button variant="ghost" size="icon" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </Button>
        </div>
      </nav>
      
      {/* Mobile menu - updated with only Blog and Learn AI */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-md">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <Link to="/blog" className="block py-2 nav-link" onClick={closeMobileMenu}>
              Blog
            </Link>
            
            <Link to="/ai-solutions" className="block py-2 nav-link" onClick={closeMobileMenu}>
              AI Solutions
            </Link>
            
            <Link to="/assistants" className="block py-2 nav-link" onClick={closeMobileMenu}>
              Advisory Assistants
            </Link>
            
            <Link to="/portfolio" className="block py-2 nav-link" onClick={closeMobileMenu}>
              Public Portfolio
            </Link>
            
            <Link to="/glossary" className="block py-2 nav-link" onClick={closeMobileMenu}>
              Glossary
            </Link>
            
            <Link to="/contact" className="block py-2 nav-link" onClick={closeMobileMenu}>
              Connect
            </Link>
            
            <a 
              href="https://workflows.thinktomorrow.ai" 
              target="_blank" 
              rel="noopener noreferrer"
              className="block py-2"
              onClick={closeMobileMenu}
            >
              <Button variant="outline" className="w-full">
                Workflow Navigator
              </Button>
            </a>
            
            <a href="https://app.thinktomorrow.ai/" className="block py-2" onClick={closeMobileMenu}>
              <Button variant="outline" className="w-full">
                Login
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
